import React from "react";
import { Contact } from "../components";

const InfosContainer: React.FC = () => (
  <Contact.Infos>
    <Contact.Item>
      <Contact.Title>Email</Contact.Title>
      <Contact.Desc>ga_bennecer@esi.dz</Contact.Desc>
    </Contact.Item>
    <Contact.Item>
      <Contact.Title>Phone</Contact.Title>
      <Contact.Desc>+213 697 31 27 71</Contact.Desc>
    </Contact.Item>
    <Contact.Item>
      <Contact.Title>Follow me</Contact.Title>
      <Contact.MediaContainer>
        <Contact.MediaLink to='#' icon='fab fa-facebook' />
        <Contact.MediaLink to='#' icon='fab fa-twitter' />
        <Contact.MediaLink to='#' icon='fab fa-instagram' />
        <Contact.MediaLink to='#' icon='fab fa-behance' />
        <Contact.MediaLink to='#' icon='fab fa-dribbble' />
        <Contact.MediaLink to='#' icon='fab fa-github' />
      </Contact.MediaContainer>
    </Contact.Item>
  </Contact.Infos>
);

export default InfosContainer;
